import { useQuery } from 'react-query';
import { getClaimsDisclaimerInformation } from 'api/get-claims-disclaimer-information';
import { QUERY_KEYS } from 'common/constants';

export const useGetClaimsDisclaimerInformation = (claimId?: string) =>
  useQuery([QUERY_KEYS.GET_CLAIMS_DISCLAIMER_STATUS_BANNER], () =>
    getClaimsDisclaimerInformation(claimId),
  );
